import { colors } from '@commutifi-fe/ui/styles/constants'
import { COMMON_DEFAULT_HEIGHT } from './constants'
import { heightWidthRatio } from './utils'

const DEFAULT_HEIGHT = 231.93
const DEFAULT_WIDTH = 301

export const SvgClosedIllustration = ({
  fill = colors.feedbackDestructive200,
  stroke = colors.neutral600,
  height,
  width,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const { height: h, width: w } = heightWidthRatio(
    !height && !width ? COMMON_DEFAULT_HEIGHT : height,
    width,
    {
      defaultHeight: DEFAULT_HEIGHT,
      defaultWidth: DEFAULT_WIDTH
    }
  )
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      height={h}
      width={w}
      viewBox={`57 37.57 ${DEFAULT_WIDTH} ${DEFAULT_HEIGHT}`}
      {...props}
    >
      <path
        fill={fill}
        d="M219.73 172.867c27.476-26.364 61.616-35.37 76.254-20.115 14.638 15.255 4.23 48.994-23.246 75.358-27.476 26.365-61.616 35.371-76.253 20.116-14.638-15.255-4.231-48.994 23.245-75.359"
      />
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={3}
        d="M105.728 89.881C93.278 108.15 86 130.225 86 154c0 62.96 51.04 114 114 114s114-51.04 114-114S262.96 40 200 40c-22.13 0-42.787 6.306-60.272 17.218"
      />
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={3}
        d="m151.78 225.546 118.909-118.909a.99.99 0 0 1 1.529.152c8.885 13.565 14.052 29.784 14.052 47.211 0 47.645-38.624 86.27-86.27 86.27a86.446 86.446 0 0 1-21.568-2.718m71.606-153.836L130.551 203.203a.99.99 0 0 1-1.515-.131c-9.651-13.931-15.306-30.841-15.306-49.072 0-47.646 38.624-86.27 86.27-86.27 10.855 0 21.242 2.005 30.811 5.664"
      />
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="m293.243 53.079 6.746-14.013m11.791 28.919 14.489-11.21m-5.674 34.009 15.756-1.762"
      />
      <path
        stroke={stroke}
        strokeWidth={3}
        d="m336.064 248.838-1.845-2.204a.905.905 0 0 1 .763-1.561l2.872.1a14.722 14.722 0 0 0 9.723-3.341l2.196-1.828a.9.9 0 0 1 1.561.763l-.092 2.855a14.65 14.65 0 0 0 3.342 9.723l1.844 2.204a.905.905 0 0 1-.762 1.561l-2.873-.1a14.8 14.8 0 0 0-9.723 3.342l-2.204 1.844a.905.905 0 0 1-1.561-.762l.1-2.873c.366-3.373-.84-6.883-3.341-9.723Z"
      />
      <path
        fill={fill}
        d="M352.099 254.274c-2.684-3.418-3.659-5.667-2.95-10.774-1.287 9.274-7.386 15.122-7.386 15.122 3.872-3.136 5.292-4.491 10.336-4.348"
      />
      <path
        stroke={stroke}
        strokeLinecap="round"
        strokeWidth={3}
        d="M65.573 41.449a6.68 6.68 0 0 1 2.515.756c3.263 1.733 4.513 5.777 2.792 9.03-1.72 3.255-5.76 4.487-9.022 2.754-3.262-1.734-4.512-5.777-2.792-9.031a6.633 6.633 0 0 1 1.243-1.662"
      />
    </svg>
  )
}
export default SvgClosedIllustration
